import { API, TOKEN_KEY } from "../lib/api";
import { X, ArrowSquareOut, LockSimple } from "@phosphor-icons/react";

export function docViewUrl(fileId) {
  return fileId ? `${API}/files/${fileId}/download?auth=${localStorage.getItem(TOKEN_KEY)}` : null;
}

// Un documento aprobado queda bloqueado (no se puede reemplazar) salvo que esté vencido.
export function isDocLocked(doc) {
  if (!doc || doc.status !== "APROBADO") return false;
  if (doc.expirationDate) {
    const days = Math.ceil((new Date(doc.expirationDate) - new Date()) / 86400000);
    if (!isNaN(days) && days < 0) return false; // vencido → se puede reemplazar
  }
  return true;
}

export function DocViewerModal({ fileId, title = "Documento", onClose }) {
  if (!fileId) return null;
  const url = docViewUrl(fileId);
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="doc-viewer-modal">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-3xl h-[85vh] flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-5 py-3 border-b border-zinc-200">
          <span className="font-semibold truncate">{title}</span>
          <div className="flex items-center gap-2">
            <a href={url} target="_blank" rel="noreferrer" data-testid="doc-viewer-open"
              className="text-sm font-semibold text-[#FF5A36] inline-flex items-center gap-1 hover:underline">
              <ArrowSquareOut size={16} /> Abrir
            </a>
            <button onClick={onClose} data-testid="doc-viewer-close" className="p-2 rounded-lg hover:bg-zinc-100 text-zinc-600"><X size={18} /></button>
          </div>
        </div>
        <iframe title="documento" src={url} className="flex-1 w-full bg-zinc-50" />
      </div>
    </div>
  );
}

export function LockedBadge() {
  return (
    <span className="h-9 px-3 rounded-lg bg-zinc-100 text-zinc-500 text-sm font-semibold inline-flex items-center gap-1.5" data-testid="doc-locked">
      <LockSimple size={16} weight="fill" /> Bloqueado
    </span>
  );
}
